import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Header from "../../components/header/Header";
import "./home.css";
import _ from "lodash";
import UserService from "../../services/user.service";
import ConversationService from "../../services/conversation.service";
import Preloader from "../../components/preloader/Preloader";

const pageSize = 10;

const StaffDatabase = () => {
	const [fetching, setFetching] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [paginatedTable, setPaginatedTable] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");

	const getUsers = async () => {
		setFetching(true);
		let res = await UserService.getAllUser();
		const data = res.allUsers;
		setTableData(data);
		setPaginatedTable(_(data).slice(0).take(pageSize).value());
		setFetching(false);
	};

	useEffect(() => {
		getUsers();
	}, []);

	const pageCount = tableData ? Math.ceil(tableData.length / pageSize) : 0;

	const pages = _.range(1, pageCount + 1);

	const handlePagination = (pageNum) => {
		setCurrentPage(pageNum);
		const startIndex = (pageNum - 1) * pageSize;
		const paginatedTableData = _(tableData)
			.slice(startIndex)
			.take(pageSize)
			.value();
		setPaginatedTable(paginatedTableData);
	};

	const currentUserRoles = (user) => {
		return user.map((role) =>
			role.name === "reviewer"
				? "REVIEWER"
				: role.name === "initiator"
				? "INITIATOR"
				: role.name === "admin"
				? "ADMIN"
				: role.name === "approver"
				? "APPROVER"
				: "USER",
		);
	};

	const conversationHandler = (id) => {
		ConversationService.startConversations(id);
		window.location.href = "/messenger";
		// window.location.href = `/messenger/${id}`;
	};

	return (
		<div className="request__page__wrapper">
			<Header />
			<div className="request__page">
				<div className="request__page__heading">STAFF DATABASE</div>

				{/* <!-- DataTales Example --> */}
				<div className="request-page__card">
					<div className="card-header">
						{/* <Form.Select
							size="lg"
							className="request__page__input"
							onChange={(e) => setSearchTerm(e.target.value)}
						>
							<option value="">ALL ENTRIES</option>
							<option value="PENDING APPROVAL">PENDING APPROVAL</option>
							<option value="PENDING REVIEW">PENDING REVIEW</option>
							<option value="APPROVED">APPROVED</option>
						</Form.Select> */}
						<Form.Control
							size="lg"
							className="request__page__input"
							type="text"
							placeholder="SEARCH..."
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</div>
					<div className="card-body">
						{paginatedTable.length === 0 ? (
							<div>No entries yet</div>
						) : (
							<div className="table-responsive">
								<table className="table" id="dataTable" width="100%" cellSpacing="0">
									{/* <thead></thead> */}
									<tbody>
										<tr className="thead">
											<th className="request__table__head">S/NO</th>
											<th className="request__table__head">NAME</th>
											<th className="request__table__head">STAFF ID</th>
											<th className="request__table__head">ROLE</th>
											<th className="request__table__head">OFFICE</th>
											<th className="request__table__head">LEVEL</th>
											<th className="request__table__head">DEPARTMENT</th>
											<th className="request__table__head">ACTION</th>
										</tr>
										{paginatedTable
											.filter((val) => {
												if (searchTerm === "") {
													return val;
												}
												if (
													val.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.lastname.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.middlename.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.employmentLocation
														.toLowerCase()
														.includes(searchTerm.toLowerCase()) ||
													val.grade.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.department.toLowerCase().includes(searchTerm.toLowerCase())
												) {
													return val;
												}
												return false;
											})
											.map((item, i) => (
												<tr key={i}>
													<td>{i + 1}.</td>
													<td className="request__body request__project__title">
														{item.firstname.toUpperCase()} {item.middlename.toUpperCase()}{" "}
														{item.lastname.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{item.staffnum.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{currentUserRoles(item.roles)}
													</td>
													<td className="request__body request__body-item">
														{item.employmentLocation.toUpperCase() ===
														"FEDERAL CAPITAL TERRITORY"
															? "ABUJA (FCT)"
															: item.employmentLocation.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{item.grade.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{item.department.toUpperCase()}
													</td>
													<td className="request__body request__body-item request-cta">
														<button onClick={() => conversationHandler(item._id)}>
															Send Message
														</button>
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						)}
					</div>
				</div>
				<nav className="d-flex justify-content-center">
					<ul className="pagination">
						{pages.map((page, idx) => (
							<li
								key={idx}
								className={page === currentPage ? "page-item active" : "page-item"}
							>
								<p className="page-link" onClick={() => handlePagination(page)}>
									{page}
								</p>
							</li>
						))}
					</ul>
				</nav>
			</div>
			{fetching && <Preloader text={"Fetching data"} />}
		</div>
	);
};

export default StaffDatabase;
